import apiRequestService from '@/commonProject/service/apiRequestService';

export default class companyManagementRepository {
    /**
     * 管理者一覧API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postMngLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/mnglst', requestBody, idToken);
        return result;
    }
    /**
     * 管理者取得API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getMngDtlActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/mngdtl', queryParam, idToken);
        return result;
    }
    /**
     * 管理者登録API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postMngDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/mngdtl', requestBody, idToken);
        return result;
    }
     /**
     * 管理者更新API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
     async putMngDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/mngdtl', requestBody, idToken);
        return result;
    }
    /**
     * 管理者削除API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
        async postMngDelActionApi(API_URL, requestBody, idToken) {
            const result = await apiRequestService.requestServerPost(API_URL + '/mngdel', requestBody, idToken);
            return result;
        }
}
